import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getPharmacyPatientMessagesV3({ pharmacyId, patientId, limit, orderBy }) {
    const response = await axiosPrivate.get(
      `/v3/pharmacist/messages?pharmacyId=${pharmacyId}&patientId=${patientId}&limit=${limit}&orderBy=${orderBy}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.messages;
  },

  async postMessageV3({ pharmacyId, patientId, messageBody }) {
    const response = await axiosPrivate.post(`/v3/pharmacist/messages`, {
      messageBody,
      pharmacyId,
      patientId,
    });

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data.message;
  },
};
